import { Link } from 'react-router-dom'

type FooterLink = { label: string; href: string; internal?: true }
const externalLinks: FooterLink[] = [
    // GitHub / npm / X / LinkedIn all live on /showcase#contact now
    // as an icon-card grid — the footer just points readers there so
    // they choose a channel.
    { label: 'Contact', href: '/showcase#contact', internal: true },
]

const legalLinks = [
    { label: 'Privacy', to: '/privacy' },
    { label: 'Terms', to: '/terms' },
    { label: 'Legal', to: '/legal' },
]

const linkClass =
    'text-[10px] uppercase tracking-widest text-text-muted hover:text-accent transition-colors'

export function LandingFooter() {
    const currentYear = new Date().getFullYear()

    return (
        <footer
            className="w-full py-16 px-8"
            style={{ borderTop: '1px solid color-mix(in srgb, var(--border) 40%, transparent)' }}
        >
            <div className="max-w-6xl mx-auto flex flex-col items-center gap-8">
                <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4 items-center text-center">
                    <span className="text-lg font-bold font-mono text-accent md:text-left">
                        EN
                    </span>

                    <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
                        {externalLinks.map((link) => (
                            'internal' in link ? (
                                <Link
                                    key={link.label}
                                    to={link.href}
                                    className={linkClass}
                                >
                                    {link.label}
                                </Link>
                            ) : (
                                <a
                                    key={link.label}
                                    href={link.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={linkClass}
                                >
                                    {link.label}
                                </a>
                            )
                        ))}
                        {legalLinks.map((link) => (
                            <Link key={link.label} to={link.to} className={linkClass}>
                                {link.label}
                            </Link>
                        ))}
                    </nav>

                    <span className="text-[10px] uppercase tracking-widest text-text-muted md:text-right">
                        &copy; {currentYear} EN Diagram
                    </span>
                </div>
                <p className="text-[10px] text-text-muted/50 text-center leading-relaxed max-w-lg">
                    EN Diagram computes structural properties from the graph you describe.
                    Results are deterministic but depend on correct input modeling.
                    Verify critical findings independently before acting on them.
                </p>
            </div>
        </footer>
    )
}
